import { render } from "./SettingsGeneralView.vue?vue&type=template&id=71878746&scoped=true"
import script from "./SettingsGeneralView.vue?vue&type=script&lang=js"
export * from "./SettingsGeneralView.vue?vue&type=script&lang=js"

import "./SettingsGeneralView.vue?vue&type=style&index=0&id=71878746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71878746"]])

export default __exports__